/**
 * websocket 数据储存
 */
const type = {
  GETLOGINLIST: "GETLOGINLIST",
  ADDLOGINLIST: "ADDLOGINLIST",
  GETMESSLIST: "GETMESSLIST",
  ADD_MESSAGELIST: "ADD_MESSAGELIST",
  GETVOTEDATA: "GETVOTEDATA",
  CHANGEVOTEDATA: "CHANGEVOTEDATA",
  DELETEVOTE: "DELETEVOTE",
  CLEANDATA: 'CLEANDATA',
  GETSIGNINFO: 'GETSIGNINFO',
  GETFEEDBACK: 'GETFEEDBACK',
  CHANGESOCKETSTATE: 'CHANGESOCKETSTATE'
};
const state = {
  webloginlist: [],
  messagelist: [], //留言板数据
  vote_main: '', //votedata.main 主体信息
  vote_item: '', //votedata.item  投票对象
  vote_total: 0,//votedata.total  总数
  dai_sign: {}, //待参加人员列表
  no_come: {}, //操作请假人员列表
  situation: {}, //情况
  num: {
    all_num: 0,
    come_num: 0,
    dai_notice_num: 0,
    no_come_num: 0,
    no_feedback_num: 0,
    notice_fail_num: 0,
    total_num: 0,
  },
  dai_comeInfo: [],
  dai_sign: [],
  no_comeInfo: [],
  comeInfo: [],
  // socketstate: false, //socket是否处于连接状态
  lastmeeting: {}
};
const mutations = {
  [type.GETLOGINLIST](state, status) {
    if (state.webloginlist) {
      state.webloginlist = []
    };
    state.webloginlist = status;
  },
  [type.ADDLOGINLIST](state, status) {
    state.webloginlist.push(status);
  },
  [type.GETMESSLIST](state, status) {
    if (state.messagelist) {
      state.messagelist = []
    };
    state.messagelist = status;
  },
  [type.ADD_MESSAGELIST](state, status) {
    state.messagelist.push(status);
  },
  [type.GETVOTEDATA](state, status) {
    state.vote_main = '';
    state.vote_item = '';
    state.vote_total = 0;
    if (status.vote) {
      state.vote_main = status.vote;
    }
    if (status.new_item) {
      state.vote_item = status.new_item;
    }
    if (status.tou_count) {
      state.vote_total = status.tou_count;
    }
  },
  // [type.CHANGEVOTEDATA](state, status) {
  //   state.vote_main = '';
  //   state.vote_item = '';
  //   if (status.main) {
  //     state.vote_main = status.main;
  //   }
  //   if (status.item) {
  //     state.vote_item = status.item;
  //   }
  //   if (status.total) {
  //     state.vote_total = status.total;
  //   }
  // },
  [type.DELETEVOTE](state, status) {
    state.votedata = status;
  },
  [type.CLEANDATA](state) {
    state.webloginlist = [];
    state.messagelist = [];
    state.votedata = {};
  },
  [type.GETSIGNINFO](state, status) {
    state.dai_sign = status.dai_sign;
    state.no_come = status.no_come;
    state.situation = status.situation;
  },
  [type.GETFEEDBACK](state, status) {
    state.num = status.num;
    state.dai_comeInfo = status.dai_comeInfo;
    state.dai_sign = status.dai_sign;
    state.no_comeInfo = status.no_comeInfo;
    state.comeInfo = status.comeInfoRank;
  },
  //改变socket状态
  [type.CHANGESOCKETSTATE](state, status) {
    state.socketstate = status;
  },
  // 存取最新活动
  SAVE_EVENTINFO: (state, data) => {
    state.lastmeeting = data;
  },
  // 清空会议数据
  CLEAR_MEETING: (state, data) => {
    state.messagelist = [], //留言板数据
      state.vote_main = '', //votedata.main 主体信息
      state.vote_item = '', //votedata.item  投票对象
      state.vote_total = 0,//votedata.total  总数
      state.dai_sign = {}, //待参加人员列表
      state.no_come = {}, //待参加人员列表
      state.situation = {}, //情况
      state.num = [],
      state.dai_comeInfo = [],
      state.dai_sign = [],
      state.no_comeInfo = [],
      state.comeInfo = [],
      state.socketstate = false, //socket是否处于连接状态
      state.lastmeeting = {}
  }

};
const getters = {

}
export default {
  type,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/websocket.js